import { useContext, useEffect, useState } from "react";
import {
  BiCheckCircle,
  BiClipboard,
  BiPackage,
  BiXCircle,
} from "react-icons/bi";
import { RefreshContext } from "../../ContextProvider";
import ApprovalModal from "../Modals/ApprovalModal";
import ReportModal from "../Modals/ReportModal";
import Profile from "../Profile/Profile";
import Button from "../Reusables/Button";

const Header = ({ pharmaStatus, selectedRows }) => {
  const { userRoles } = useContext(RefreshContext);

  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [toStatus, setToStatus] = useState("");

  const [hasApproved, setHasApproved] = useState(false);
  const [hasNeedsApproval, setHasNeedsApproval] = useState(false);
  const [hasRejected, setHasRejected] = useState(false);
  const [hasDispatched, setHasDispatched] = useState(false);
  const [hasPassed, setHasPassed] = useState(false);
  const [rejectOnly, setRejectOnly] = useState(false);

  useEffect(() => {
    // Reset status flags
    setHasApproved(false);
    setHasNeedsApproval(false);
    setHasRejected(false);
    setHasDispatched(false);
    setHasPassed(false);
    setRejectOnly(false);

    // loop through selected rows and set status flags
    selectedRows.forEach((row) => {
      console.log("row", row);
      if (row.pharmacy_status === "Approved") {
        setHasApproved(true);
      }
      if (
        row.pharmacy_status === "Needs Approval" ||
        row.pharmacy_status === "Cancel Subscription" ||
        row.pharmacy_status === "Suspected 2x Sub"
      ) {
        setHasNeedsApproval(true);
      }
      if (row.pharmacy_status === "Rejected") {
        setHasRejected(true);
      }
      if (row.pharmacy_status === "Dispatched") {
        setHasDispatched(true);
      }
      if (row.pharmacy_status === "Passed") {
        setHasPassed(true);
      }
      if (row.pharmacy_status === "Cancel Sub & Order") {
        setRejectOnly(true);
      }
    });
  }, [selectedRows]);

  return (
    <>
      <header className="sticky top-0 z-20 flex items-center justify-between border-b bg-white px-4 py-2">
        <Profile />
        <Button
          className="ml-4 mr-auto"
          onClick={() => setShowReportModal(true)}
        >
          <BiClipboard size="20px" />
          <span className="hidden sm:block">Report</span>
        </Button>
        <div
          className={
            "grid h-fit gap-2 md:w-fit " +
            (userRoles.includes("Pharmacist") ? "grid-cols-3" : "")
          }
        >
          <Button
            color="blue"
            disabled={
              !userRoles.includes("Admin")
                ? selectedRows.length === 0 ||
                  !hasApproved ||
                  hasDispatched ||
                  hasNeedsApproval ||
                  hasRejected ||
                  hasPassed
                : selectedRows.length === 0
            }
            onClick={() => {
              setToStatus("Dispatched");
              setShowApprovalModal(true);
            }}
          >
            <BiPackage size="20px" />
            <span className="hidden sm:block">Dispatch</span>
          </Button>
          {userRoles.includes("Pharmacist") && (
            <>
              <Button
                color="green"
                disabled={
                  selectedRows.length === 0 ||
                  (!hasNeedsApproval && !hasPassed) ||
                  hasApproved ||
                  hasRejected ||
                  hasDispatched ||
                  rejectOnly
                }
                onClick={() => {
                  setToStatus("Approved");
                  setShowApprovalModal(true);
                }}
              >
                <BiCheckCircle size="20px" />
                <span className="hidden sm:block">Approve</span>
              </Button>
              <Button
                color="red"
                disabled={
                  !userRoles.includes("Admin")
                    ? selectedRows.length === 0 ||
                      hasApproved ||
                      (!hasNeedsApproval && !hasPassed && !rejectOnly) ||
                      hasDispatched ||
                      hasRejected
                    : selectedRows.length === 0
                }
                onClick={() => {
                  setToStatus("Rejected");
                  setShowApprovalModal(true);
                }}
              >
                <BiXCircle size="20px" />
                <span className="hidden sm:block">Reject</span>
              </Button>
            </>
          )}
        </div>
      </header>

      <ReportModal isOpen={showReportModal} setIsOpen={setShowReportModal} />

      <ApprovalModal
        isOpen={showApprovalModal}
        setIsOpen={setShowApprovalModal}
        data={selectedRows}
        toStatus={toStatus}
      />
    </>
  );
};

export default Header;
